/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import NoiseSource from './noise-source';
import BaseNoiseGroup from '../../implementation-common/base-noise-group';

export default class FirstOrderHighPass extends BaseNoiseGroup {
  c1 = null;
  r1 = null;
  r3 = null;
  r4 = null;
  frequencyArray = null;
  opAmp = null;

  @computed('c1', 'r1', 'r3', 'r4', 'opAmp', 'filterAmplitude') get noiseReferredToOutputArray() {
    var c1 = this.c1;
    var r1 = this.r1;
    var r3 = this.r3;
    var r4 = this.r4;
    var opAmp = this.opAmp;
    var filterAmplitude = this.filterAmplitude;
    var complexRParallelArray = filterAmplitude.map((item) => {
      return item.complexRParallel;
    });
    var sImaginaryArray = filterAmplitude.map((item) => {
      return item.sImaginary;
    });
    var iNoise = opAmp.iNoise;
    var vNoise = opAmp.vNoise;
    var noiseSource = NoiseSource.create({
      c1: c1,
      r1: r1,
      r3: r3,
      r4: r4,
      opAmp: opAmp,
      iNoise: iNoise,
      vNoise: vNoise,
    });
    var result = filterAmplitude.map((item, index) => {
      var complexRParallel = complexRParallelArray[index];
      var sImaginary = sImaginaryArray[index];
      return noiseSource.totalNoise(item, complexRParallel, sImaginary);
    });

    return result;
  }

  @computed('noiseReferredToOutputArray', 'magnitude', 'frequencyArray') get noiseReferredToInputArray() {
    var frequencyArray = this.frequencyArray;
    var noiseReferredToOutputArray = this.noiseReferredToOutputArray;
    var magnitude = this.magnitude;
    var result = frequencyArray.map((item, index) => {
      var res = noiseReferredToOutputArray[index] / magnitude[index];
      return res;
    });

    return result;
  }
}
